// extracted by mini-css-extract-plugin
export default {"overlay":"l0ux8Grmy7J1wE8jLfxt"};